import { writable } from 'svelte/store';

// primary nav
export const selectedPrimaryNavItem = writable<primaryNavTabs>('');

// seconday nav selected options
export const homeSelectedTab = writable<homeNavItems>('home');
export const myProfileSelectedTab = writable<profileNavItems>();
export const otherProfileSelectedTab = writable<profileNavItems>(' ');
export const createSelectedTab = writable<createNavItems>('Post Details');
export const isHomeMenuOpen = writable<boolean>(false);
export const isProfileMenuOpen = writable<boolean>(true);
export const PostBoxSelected = writable<boolean>(false);
export const isDraft = writable<boolean>(false);
export const noNav = writable<boolean>(false);
